import { cn } from '@bw/core';
import { Block } from '../../factories/types';
import { schemeToClass } from '../../utils/colorMap';
import { ColumnsItem } from './ColumnsItem';
import styles from './ColumnsSection.module.scss';
import { GridItem } from './GridItem';

export const ColumnsSection: Block<'columnsSection'> = ({
	data: {
		fields: { items, appearance = 'Columns', colorScheme = 'Default (white)' },
	},
	fieldId,
	render,
}) => (
	<section
		className={cn(
			styles.columnsSection,
			appearance === 'Columns' && styles.columns,
			appearance === 'Grid' && styles.grid,
			schemeToClass(colorScheme)
		)}
		{...fieldId('items')}
	>
		{render(items, {
			template: appearance === 'Columns' ? ColumnsItem : GridItem,
		})}
	</section>
);
